import React from 'react'
// import PropTypes from 'prop-types'
import styled from '@emotion/styled'

// import IconTitle from 'components/IconTitle';
import SlickBar from 'components/SlickBar';
import CategoryThumbnail from '../elements/CategoryThumbnail';

import vw from 'styles/utils';
import media from 'styles/media';

import data from 'data/trend';
import mainCategories from 'data/mainCategories';

function Trend() {
  return (
    <Root>
      <SlickBar
        icon={require('assets/images/icons/carbon_blog.png')}
        title="AI 趨勢文章"
        slidesToShow={4}
        slidesToScroll={4}
        moreUrl="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&indu_idno=17&domain=82"
      >
        {
          mainCategories.map((category, index) => (
            <CategoryThumbnail 
              title={category.title}
              backgroundURL={data[index]}
              // subtitle1={category.subtitle1}
              href1={category.href1} 
              // subtitle2={category.subtitle2}
              // href2={category.href2}
              key={category.title}
            />
          ))
        }
      </SlickBar>

      {/* <IconTitle 
        title="AI 趨勢文章"
        iconImage={require('assets/images/icons/carbon_blog.png')}
      />
      <CategoryButtonRow>
        {
          mainCategories.map((category) => (
            <CategoryThumbnail 
              title={category.title} 
              // subtitle1={category.subtitle1}
              href1={category.href1} 
              // subtitle2={category.subtitle2}
              // href2={category.href2}
              key={category.title}
            />
          ))
        }
      </CategoryButtonRow> */}
    </Root>
  )
}

Trend.propTypes = {}

const Root = styled.section`
  /* display: grid;
  grid-template-columns: auto auto;

  @media ${media.tablet} {
    grid-template-columns: auto auto auto;
  }

  @media ${media.desktop} {
    grid-template-columns: auto auto auto auto;
  }
  
  ${vw('height', 240, 100, 120)}
  ${vw('grid-column-gap', 10, 12, 24)}
  ${vw('grid-row-gap', 10, 0)} */
`;

// const CategoryButtonRow = styled.div`
//   display: grid;
//   grid-template-columns: auto auto;

//   @media ${media.tablet} {
//     grid-template-columns: auto auto auto;
//   }

//   @media ${media.desktop} {
//     grid-template-columns: auto auto auto auto;
//   }
  
//   ${vw('height', 240, 100, 120)}
//   ${vw('grid-column-gap', 10, 12, 24)}
//   ${vw('grid-row-gap', 10, 0)}
// `;

export default Trend
